
import "./pageTitle.scss";

export default function PageTitle(props) {

    const { title, style, right } = props;

    return (
        <div className="gp-theme-bdcolor-sc gp-theme-bgcolor page-title" style={{...style}} >
            <span>{title}</span>
            <span style={{marginLeft: "auto", display: "block"}} >
                {right}
            </span>
        </div>
    )

}